import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  padding: 24px;
  box-sizing: border-box;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const ActionButton = styled.button<{ $primary?: boolean }>`
  cursor: pointer;
  border-radius: 8px;
  padding: 10px 20px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid ${({ theme }) => theme.colors.prussianBlue};
  color: ${({ theme, $primary }) => ($primary ? theme.colors.white : theme.colors.prussianBlue)};
  background: ${({ theme, $primary }) => ($primary ? theme.colors.prussianBlue : 'transparent')};
`;
